import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setOpenModal, setLoading, setError, setIsSaved } from "../../../global-state/redux";
import { postRequest } from "../../../network/httpRequest";
import { urls } from "../../../constant";
import { FaSync } from "react-icons/fa";

const EditMemberSyncModal = ({ data }) => {
  const dispatch = useDispatch();
  const [isSyncing, setIsSyncing] = useState(false);
  const [formData, setFormData] = useState({
    first_name: data?.first_name || "",
    last_name: data?.last_name || "",
    gender: data?.gender || "",
    umva_cardid: data?.umva_cardid || "",
    province: data?.province || "",
    commune: data?.commune || "",
    zone: data?.zone || "",
    colline: data?.colline || "",
    localite: data?.localite || "",
    group: data?.group || "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSyncMember = async () => {
    setIsSyncing(true);
    dispatch(setLoading());
    
    // Sync the member with updated form data
    const syncResponse = await postRequest(
      `${urls.deposit}/new-members/${data.id}/sync`,
      "json",
      { ...data, ...formData }
    );
    
    dispatch(setLoading());
    setIsSyncing(false);
    
    if (syncResponse.err) {
      return dispatch(setError({ 
        err: syncResponse.err, 
        msg: syncResponse.msg, 
        data: syncResponse.data, 
        typeErr: syncResponse.typeErr 
      }));
    }
    
    // Extract sup_name from the response
    const supName = syncResponse.data?.['0']?.sup_name || syncResponse.data?.sup_name;
    const umvaId = syncResponse.data?.umva_id;
    
    // Show success message with sup_name
    const successMessage = supName 
      ? `Membre synchronisé avec succès! Nom d'utilisateur: ${supName}${umvaId ? ` (UMVA ID: ${umvaId})` : ''}`
      : "Membre synchronisé avec succès!";
    
    dispatch(setError({ 
      err: true, 
      msg: successMessage, 
      typeErr: "success" 
    }));
    
    dispatch(setIsSaved());
    dispatch(setOpenModal({ actionName: "", data: null, actionTitle: "", number: 0 }));
  };

  const handleCancel = () => {
    dispatch(setOpenModal({ actionName: "", data: null, actionTitle: "", number: 0 }));
  };

  const fieldStyle = {
    marginBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
    color: '#333',
    fontSize: '14px',
  };

  const inputStyle = {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.3s',
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '1px solid #eee',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
  };

  const headerStyle = {
    marginBottom: '20px',
    paddingBottom: '15px',
    borderBottom: '2px solid #4CAF50',
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={headerStyle}>
        <h3 style={{ margin: 0, color: '#333', fontSize: '18px' }}>
          Vérifier et modifier les données avant synchronisation
        </h3>
        <p style={{ margin: '8px 0 0 0', color: '#666', fontSize: '13px' }}>
          Veuillez vérifier les informations ci-dessous avant de synchroniser avec le système NEPAL
        </p>
      </div>

      <div style={gridStyle}>
        <div style={fieldStyle}>
          <label style={labelStyle}>Prénom *</label>
          <input
            type="text"
            name="first_name"
            value={formData.first_name}
            onChange={handleInputChange}
            style={inputStyle}
            required
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Nom *</label>
          <input
            type="text"
            name="last_name"
            value={formData.last_name}
            onChange={handleInputChange}
            style={inputStyle}
            required
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Sexe *</label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleInputChange}
            style={inputStyle}
            required
          >
            <option value="">Sélectionner</option>
            <option value="M">Masculin</option>
            <option value="F">Féminin</option>
          </select>
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>UMVA Card ID *</label>
          <input
            type="text"
            name="umva_cardid"
            value={formData.umva_cardid}
            onChange={handleInputChange}
            style={inputStyle}
            required
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Province *</label>
          <input
            type="text"
            name="province"
            value={formData.province}
            onChange={handleInputChange}
            style={inputStyle}
            required
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Commune *</label>
          <input
            type="text"
            name="commune"
            value={formData.commune}
            onChange={handleInputChange}
            style={inputStyle}
            required
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Zone</label>
          <input
            type="text"
            name="zone"
            value={formData.zone}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Colline</label>
          <input
            type="text"
            name="colline"
            value={formData.colline}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Localité</label>
          <input
            type="text"
            name="localite"
            value={formData.localite}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>

        <div style={fieldStyle}>
          <label style={labelStyle}>Groupe</label>
          <input
            type="text"
            name="group"
            value={formData.group}
            onChange={handleInputChange}
            style={inputStyle}
          />
        </div>
      </div>

      <div style={buttonContainerStyle}>
        {isSyncing ? (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            padding: '10px',
            color: 'var(--td-blue)',
            fontSize: '14px',
            fontWeight: 'bold'
          }}>
            <FaSync className="spinning" />
            <span>Synchronisation en cours...</span>
          </div>
        ) : (
          <>
            <button
              onClick={handleCancel}
              style={{
                backgroundColor: 'var(--td-secondary)',
                color: 'white',
                padding: '10px 24px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              Annuler
            </button>
            <button
              onClick={handleSyncMember}
              style={{
                backgroundColor: 'var(--td-primary)',
                color: 'white',
                padding: '10px 24px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
              }}
            >
              <FaSync />
              Synchroniser
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default EditMemberSyncModal;
